import { toolingMetricsApiFetch } from '@/shared/utils/api';
import { API_PATH_EVENTS } from '@/shared/constants';
import { EventMetric } from '@/shared/types/event-metrics';

/**
 * @method postMetricEvent
 * @description Creates a new metric event. Always fire-and-forget — no caller awaits or
 * inspects the result — so failures are swallowed here instead of leaking as unhandled
 * promise rejections. The HTTP failure is still reported to Sentry generically by
 * reportApiError in shared/utils/api.ts.
 * @param event
 */
export const postMetricEvent = async (event: EventMetric): Promise<void> => {
  try {
    await toolingMetricsApiFetch('POST', API_PATH_EVENTS, event);
  } catch {
    // Intentionally swallowed — see function doc.
  }
};
